import '../styles/header.scss'

export default function Footer() {
    return(
        <footer>
            <h4>Developed by <a href="https://nitrosolutions.co.uk/" target="_blank">Nitro Solutions</a></h4>
        </footer>
    )
}